/**
 * 浸水想定関連JSON取得
 */
import logger from "./../../lib/logger";
import Repository from "./../JsonRepository";

const resource = "";

export default {
    /**
    *  浸水想定関連情報取得（市町村）
    * @param {*} townCd 市町村コード
    */
    getInundations(townCd) {
        let path = "inundation/" + townCd + ".json";
        logger.debug("json getInundations(" + path + ")");
        return Repository.get(`${resource}` + path);
    }
}